<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar :pageName="'Resources'"></navbar>
			<!--导航-->
			<!--块1-->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit">CorDx News</div>
				<div class="txt">For Families, For Caregivers, For YOU</div>
			</div>
			<!--块1-->
			<!--banner-->
			<div class="banner_box"	
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img src="../../assets/img/Resources.webp" />
			</div>
			<!--banner-->
			<!--块2-->
			<div class="block_2">
				<div class="title"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>Latest from our blog</div>
				<div class="tags"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div :class="jqStatus == '' ? 'actived' : ''" @click="isClickHandle('')">All</div>
					<div :class="jqStatus == 2 ? 'actived' : ''" @click="isClickHandle(2)">Articles</div>
				</div>
				<div class="list_box">
					<div v-if="jqNewsData.length > 0" v-loading="jqLoading" class="list_box_main">
						<div
							v-for="(value, index) in jqNewsData"
							:key="index"
							class="list_box_el"
							@mouseover="newsOver(value.id)"
							@mouseleave="newsLeave"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
							@click="goResourcesInfo(value)"
						>
							<img :src="value.image" />
							<div class="msg_box">
								<div class="txt">{{ value.title }}</div>
							</div>
							<div class="time">{{ value.fabu_time }}</div>
							<div v-if="isShow == value.id" class="mask_box"
								data-aos="fade-up"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
							>
								<div class="mask_tit">{{ value.title }}</div>
								<div class="mask_txt">{{ value.description }}</div>
							</div>
						</div>
					</div>
					<div v-if="isJqAll" class="btn_box_more btn_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						@click="jqLoadAll"
					>
						Load More
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3">
				<div class="title"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>Press releases</div>
				<div class="tags"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="actived">All</div>
				</div>
				<div v-if="wqNewsData.length > 0" v-loading="wqLoading" class="list_box">
					<div class="list_box_main">
						<div
							v-for="(value, index) in wqNewsData"
							:key="index"
							class="list_box_el"
							data-aos="fade-in"
							data-aos-duration="400"
							data-aos-delay="100"
							data-aos-offset="0"
							data-aos-once="true"
							@click="goResourcesInfo(value)"
						>
							<div class="left">
								<div class="txt">{{ value.fabu_time }}</div>
								<div class="tit">{{ value.title }}</div>
							</div>
							<div class="right">
								<img src="../../assets/img/组 32@2x.png" />
							</div>
						</div>
					</div>
					<div v-if="isWqAll" class="btn_box_more btn_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						@click="WqLoadAll"
					>
						Load More
					</div>
				</div>
			</div>
			<!--块3-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import fixed from '@/component/pc/fixed.vue'  //联系我们悬浮
import { resourcesList } from '@/api/public';
export default {
	components:{
		navbar,
		footerBox,
		fixed,
	},
	data() {
		return {
			isLoading: false,  //界面loading
			isShow: null,
			jqNewsData: [],
			wqNewsData: [],
			jqStatus: '',
			jqLoading: false,
			isJqAll: true,
			wqLoading: false,
			isWqAll: true,
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		document.title = 'Resources - CorDx';
	},
	mounted() {
		let that = this;
		//请求近期新闻
		that.getJqData(6);
		//请求往期新闻
		that.getWqData(6);
	},
	watch: {
		//
	},
	methods: {
		//点击进去新闻详情
		goResourcesInfo(value) {
			let that = this;
			// let { href } = that.$router.resolve({
			// 	path: '/resources-info',
			// 	query: {
			// 		id: value.unionid,
			// 	}
			// });
			// window.open(href, '_blank');
			let routeData = that.$router.resolve({name: "Resourcesinfo", params: { resourcesInfoId: value.custom } });
			window.open(routeData.href, '_blank');
		},
		//新闻状态切换
		isClickHandle(value) {
			let that = this;
			that.jqStatus = value;
			that.getJqData(99999999);
			that.isJqAll = true;
		},
		//往期翻页
		WqLoadAll() {
			let that = this;
			that.getWqData(99999999);
			that.isWqAll = false;
		},
		//近期翻页
		jqLoadAll() {
			let that = this;
			that.getJqData(99999999);
			that.isJqAll = false;
		},
		//请求往期新闻
		getWqData(limit) {
			let that = this;
			that.WqLoading = true;
			resourcesList({
				catid: 2,
				is_tuijian: '',
				page: 1,
				page_size: limit,
				language: sessionStorage.getItem('lang'),
			}).then(res2 => {
				that.wqNewsData = res2.data.data;
				that.wqLoading = false;
			});
		},
		//请求近期新闻
		getJqData(limit) {
			let that = this;
			that.jqLoading = true;
			resourcesList({
				catid: 1,
				is_tuijian: that.jqStatus,
				page: 1,
				page_size: limit,
				language: sessionStorage.getItem('lang'),
			}).then(res2 => {
				that.jqNewsData = res2.data.data;
				that.jqLoading = false;
			});
		},
		//新闻滑入
		newsOver(value) {
			let that = this;
			that.isShow = value;
		},
		//新闻滑出
		newsLeave() {
			let that = this;
			that.isShow = null;
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	/*块3*/
	.block_3{
		width: 1140px;
		margin: 0 auto;
		.list_box{
			padding: 50px 0 70px 0;
			.list_box_main{
				position: relative;
				overflow: hidden;
				.list_box_el:hover{
					color: #0B318F;
				}
				.list_box_el:hover{
					.right{
						transform: translateX(6px);
					}
				}
				.list_box_el{
					display: flex;
					align-items: center;
					padding: 20px 0;
					border-bottom: 1px solid #999999;
					cursor: pointer;
					.left{
						flex: 1;
						padding-right: 50px;
						.txt{
							padding-bottom: 5px;
							font-size: 18px;
							color: #706B69;
						}
						.tit{
							font-size: 22px;
						}
					}
					.right{
						width: 20px;
						margin-right: 6px;
						transition: all 0.3s;
						img{ width: 100%; }
					}
				}
			}
			.btn_box{
				margin-top: 50px;
				margin-left: 42%;
			}
		}
		.tags{
			div{
				display: inline-block;
				margin-right: 20px;
				background: #FFFFFF;
				border-radius: 22px;
				border: 1px solid #eaeaea;
				font-size: 20px;
				color: #0B318F;
				padding: 8px 20px 4px 20px;
				cursor: pointer;
			}
			div.actived{
				background-color: #F5F8FA;
				border: 1px solid #0B318F;
			}
		}
		.title{
			padding-bottom: 30px;
			font-size: 45px;
		}
	}
	/*块2*/
	.block_2{
		width: 1140px;
		margin: 0 auto;
		padding-top: 80px;
		.list_box{
			padding: 50px 0 70px 0;
			.list_box_main{
				position: relative;
				overflow: hidden;
				.list_box_el{
					display: inline-block;
					width: 30%;
					height: 550px;
					margin: 0 1.5% 2% 1.5%;
					float: left;
					position: relative;
					background-color: #ffffff;
					box-shadow: 0 0 8px rgb(200, 200, 200, 0.2);
					cursor: pointer;
					overflow: hidden;
					.mask_box{
						position: absolute;
						width: 100%;
						height: 100%;
						top: 0;
						background-color: #ffffff;
						padding: 34px;
						.mask_tit{
							font-size: 20px;
							color: #000000;
						}
						.mask_txt{
							padding-top: 40px;
							font-size: 16px;
							color: #706B69;
						}
					}
					.msg_box{
						width: 100%;
						padding: 30px 34px 120px 34px;
						border-top: 2px solid #0B318F;
						.txt{
							color: #000000;
							font-size: 22px;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 5;
							overflow: hidden;
							text-overflow: ellipsis;
						}
					}
					.time{
						position: absolute;
						z-index: 2;
						bottom: 40px;
						left: 34px;
						font-size: 18px;
						color: #706B69;
					}
					img{
						width: 100%;
						// height: auto;
						height: 227px;
						object-fit: cover;
					}
				}
			}
			.btn_box{
				margin-top: 20px;
				margin-left: 42%;
			}
		}
		.tags{
			div{
				display: inline-block;
				margin-right: 20px;
				background: #FFFFFF;
				border-radius: 22px;
				border: 1px solid #eaeaea;
				font-size: 20px;
				color: #0B318F;
				padding: 8px 20px 4px 20px;
				cursor: pointer;
			}
			div.actived{
				background-color: #F5F8FA;
				border: 1px solid #0B318F;
			}
		}
		.title{
			padding-bottom: 30px;
			font-size: 45px;
		}
	}
	/*块1*/
	.block_1{
		width: 1140px;
		margin: 0 auto;
		padding: 50px 50px 0 50px;
		color: #000000;
		text-align: center;
		.tit{
			font-size: 65px;
		}
		.txt{
			font-size: 30px;
		}
	}
	/*banner*/
	.banner_box{
		img{
			width: 100%;
		}
	}
	/*按钮*/
	.btn_box_more{
		display: inline-block;
		padding: 0 28px;
		height: 42px;
		line-height: 42px;
		font-size: 20px;
		color: #0B318F;
		background: #FFFFFF;
		border-radius: 22px 22px 22px 22px;
		border: 1px solid #0B318F;
		text-align: center;
		cursor: pointer;
		img{
			width: 20px;
			position: relative;
			top: 10px;
			left: 10px;
			transition: all 0.3s;
		}
	}
	.btn_box_more:hover{
		img{
			transform: translateX(6px);
		}
		background-color: #f5f8fa;
	}
}
</style>
